define([
    'core/urls',
    'moment',
    'core/browser-storage',
    'components/modal',
    'core/iterate',
    'components/pagination',
    'components/search-field',
    'components/fake-progress',
    'components/dropdown',
    'components/request-time-manager',
    'components/metrics',
    'components/custom-encode-uri',
    'components/automation-banner',
    'core/utilities',
    'core/constants',
    'components/filter-box'
],
function (
        urls, 
        moment, 
        browser_storage, 
        modal, 
        iterate, 
        initPagination, 
        initSearchField, 
        FakeProgress, 
        DD, 
        requestTM, 
        keyMetrics,
        customEncodeUri,
        automationBanner,
        utilities,
        constants,
        filterBox
    ) 
{

    let nodes =  {
        resultWrap: document.querySelector(".table-results-wrap"),
        waitMessage: document.querySelector(".wait-message"),
        noResultsTable: document.querySelector(".table-results-wrap .no-results"),
        tableScrollWrap: document.querySelector(".table-results-wrap .scroll-wrap"),
        settingsPanel: document.querySelector(".settings-panel"),
        settingsContent: document.querySelector(".settings-panel .content"),
        settingsToggles: document.querySelectorAll(".settings-toggle"),
        pageSettingsToggle: document.querySelector(".settings-toggle-wrap .page-settings-toggle-wrap"),
        pageSettingsContent: document.querySelector(".settings-content[data-content='page-settings']"),
        filterSettingsContent: document.querySelector(".settings-content[data-content='filter-settings']"),
        filterSettingsToggle: document.querySelector(".settings-toggle-wrap.filter-toggle-wrap"),
        filterSettingsToggleLabel: document.querySelector(".settings-toggle-wrap .label"),
        filterSettings: document.querySelector(".settings-panel"),
        filterStatus: document.querySelector(".filter-status"),
        filtersReset: document.querySelector(".reset-settings"),
        filterLimiters: document.querySelectorAll(".limit-responses .mini-toggle input"),
        dateStatus: document.querySelector(".page-header.responses .date-range #datepicker"),
        preserveFilters: document.querySelector("#preserveFiltersToggle"),
        responsesHeader: document.querySelector(".page-header.responses"),
        campaign: {
            filterList: document.querySelector(".filter-campaigns-list_js"),
            wrap: document.querySelector(".filter-campaigns_js"),
            input: document.querySelector(".filter-campaigns-input_js"),
            btn: document.querySelector(".filter-toggle-campaigns_js"),
            checkers: document.querySelectorAll(".campaign-checker_js"),
            chipsWrap: document.querySelector(".campaigns-chips_js"),
            clearBtn: document.querySelector(".campaigns-clear-btn_js"),
            chips: document.querySelectorAll(".campaign-chip_js"),
        },
        responses: {
            wrap: document.querySelector(".nps-responses_js")
        },
        sentimentsMetrics: [...document.querySelectorAll(".sentiment-grayscale_js .card__content-item")],
        metrics: {
            main: document.querySelector(".metrics-header-wrap.global"),
            wrap: document.querySelector(".metrics-wrap"),
            metricsContainer: document.querySelector(".metrics-wrap .metrics"),
            header: document.querySelector(".page-header.metrics"),
            detractors: document.querySelector(".metrics-nps-det_js"),
            passives: document.querySelector(".metrics-nps-pas_js"),
            promoters: document.querySelector(".metrics-nps-pro_js"),
            result: document.querySelector(".metrics-nps_js"),
            rate: document.querySelector(".metrics-nps-rate_js"),
            status: document.querySelector(".metrics-nps-status_js"),
            responded: document.querySelector(".metrics-nps-responded_js"),
            sent: document.querySelector(".metrics-nps-sent_js"),
            toolTip: document.querySelector(".metrics-nps-tooltip_js"),
            benchmarksToggle: document.querySelector("#toggleBenchmarks"),
        },
        miniMetrics: {
            wrap: document.querySelector(".mini-metrics-wrap"),
            score: document.querySelector(".mini-metrics .score .value"),
            responses: document.querySelector(".mini-metrics .responses .value"),
            promoters: document.querySelector(".mini-metrics .responses .promoters"),
            passives: document.querySelector(".mini-metrics .responses .passives"),
            detractors: document.querySelector(".mini-metrics .responses .detractors"),
            responseRate: document.querySelector(".mini-metrics .response-rate .value"),
        },
        searchField: {
            searchField: document.querySelector(".search-response_js"),
            resetBtn: document.querySelector(".search-response-reset_js"),
            openBtn: document.querySelector(".search-response-open_js"),
            wrap: document.querySelector(".results-search-wrap_js")
        },
        pagination: {
            wrap: document.querySelector(".pagination_js"),
            page: document.querySelector(".pagination_page_js"),
            hole: document.querySelector(".pagination_hole_js")
        },
        scrollButtons: {
            wrapper: document.querySelector(".scroll-buttons"),
            left: document.querySelector(".scroll-buttons .left"),
            right: document.querySelector(".scroll-buttons .right"),
        },
        selectLimit: document.querySelector(".nps-responses-limit_js"),
        modals: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".nps-responses"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ]
        },
    }

    let metricsComponent = keyMetrics.init(nodes.metrics, "responses");
    metricsComponent.initBenchmarks();
    metricsComponent.adjustMetricsHeight();

    window.addEventListener("resize", () => {
        metricsComponent.adjustMetricsHeight();
        showHideTableScroll();
    });
    
    let platform = document.querySelector(".nps-responses").getAttribute('data-platform');
    let pagination;
    let preserveFilters = browser_storage.getItem("nps-responses-preserve-filters") || false;

    let dataCacheTimeRemaining = 0;
    let cacheTimer;

    let currentResponses;

    let isAdmin = document.querySelector(".nps-responses.sb-page").dataset.isAdmin === "True" ? true : false;
    
    var optimizedResize = (function () {

        var callbacks = [],
            running = false;

        let windowWidth = window.innerWidth;

        // fired on resize event
        function resize() {

            if(windowWidth !== window.innerWidth) {
                windowWidth = window.innerWidth;

                if (!running) {
                    running = true;

                    if (window.requestAnimationFrame) {
                        window.requestAnimationFrame(runCallbacks);
                    } else {
                        setTimeout(runCallbacks, 66);
                    }

                    utilities.setSettingsHeight(nodes);
                }
            }
        }

        // run the actual callbacks
        function runCallbacks() {
            callbacks.forEach(function (callback) {
                callback();
            });

            running = false;
        }

        // adds callback to loop
        function addCallback(callback) {
            if (callback) {
                callbacks.push(callback);
            }
        }

        return {
            // public method to add additional callback
            add: function (callback) {
                if (!callbacks.length) {
                    window.addEventListener('resize', resize);
                }
                addCallback(callback);
            }
        }
    }());

    let loaderElement = document.querySelector(".marketing-loader");
    let hint = loaderElement.querySelector(".loader-bar-wrap_hint");

    hint.innerText = "Your results are loading. Please wait.";
    
    let initialLoader = new FakeProgress(
        document.querySelector(".marketing-loader .loader-bar-wrap-bar")
    );

    let contactsProgress = new FakeProgress(
        document.querySelector(".loader-bar-wrap_contacts_js .loader-bar-wrap-bar")
    );

    let filtersProgress = new FakeProgress(
        document.querySelector(".settings-panel .loader-bar")
    );

    var createdModal = modal.create(nodes.modals, function () {});
    
    nodes.waitMessage.classList.add("disabled");

    let filterParams;

    // params for sorting / search / pagination and non-filter category filtering
    let queryParams = {
        q: "",
        limit: 10,
        page: 1,
        sort: {date: "desc"},
        platform,
    }

    let defaultDateRange = [moment().subtract(90, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];

    // params specific to date selections
    let dateParams = {
        preset: "Last 90 days",
        date: defaultDateRange,
    }

    let tableColumns = browser_storage.getItem("nps-responses-table-columns") ? JSON.parse(browser_storage.getItem("nps-responses-table-columns")) : [];
    let availableColumns = [];

    if(platform === "cw") {
        // these columns do not come from the backend like the rest of the filters, so we need to provide them as options here
        availableColumns = ["is_billing", "is_primary"]; 
    }

    //request
    let startedGetContacts = false;
    let dataTimeManager = new requestTM();

    function getData(callback) {
        loaderElement.classList.remove("disabled");
        initialLoader.startLoading(15);              
        
        if (startedGetContacts) {
            dataTimeManager.abort({success: true});
        } else {
            contactsProgress.wrap.classList.remove("disabled");
            contactsProgress.startLoading(10);
            filtersProgress.node.classList.remove("disabled");
            filtersProgress.startLoading(10);
            nodes.resultWrap.classList.add("loading");
            nodes.waitMessage.classList.remove("disabled");
            nodes.noResultsTable.classList.add("hide");
            nodes.tableScrollWrap.classList.remove("hide");
            startedGetContacts = true;
        }

        let link = urls['nps:responses-data'](dateParams.date[0], dateParams.date[1]);

        dataTimeManager.start((error) => {
            startedGetContacts = false;
            contactsProgress.loadFinish();
            filtersProgress.loadFinish();
            createdModal.open({
                class: "error-modal",
                content: error_modal.innerHTML,
                title: ""
            }, function (el) {
                el.querySelector(".button-primary").addEventListener("click", createdModal.close);
            });

        });

        contactsProgress.reset();
        filtersProgress.reset();

        let dataRequest = () => {
            var xhr = new XMLHttpRequest();

            xhr.open("GET", link + "?data=" + encodeURIComponent(JSON.stringify({...filterParams, ...queryParams})), true);
            dataTimeManager.addXHR(xhr); //FIXME Should be placed after xhr.open to work in IE 11
            xhr.setRequestHeader("Content-Type", "application/json");

            xhr.onreadystatechange = function () {
                let data = {};

                try {
                    data = JSON.parse(xhr.responseText);
                } catch (e) {
                    data = {success: false};
                }

                switch (true) {
                    case xhr.status === 500:
                        startedGetContacts = false;
                        contactsProgress.loadFinish();
                        filtersProgress.loadFinish();
                        loaderElement.classList.add("disabled");
                        initialLoader.loadFinish();
                        dataTimeManager.abort();
                        nodes.resultWrap.classList.remove("hide");
                        break;

                    case xhr.status === 0:
                        data = {success: false};
                        return;

                    case xhr.status !== 200:
                        data = {success: false};
                        startedGetContacts = false;
                        break;
                }

                new Promise(function(resolve) { 
                    let timeout = data.success ? 300 : 0
                    setTimeout(resolve, timeout); 
                }).then(function() { 
                    if (data.success) {
                        clearInterval(cacheTimer);

                        dataCacheTimeRemaining = globals.settings.NPS_CACHE_TTL;

                        cacheTimer = setInterval(() => {
                            dataCacheTimeRemaining --;

                            if(dataCacheTimeRemaining === 0) {
                                clearInterval(cacheTimer);
                            }
                        }, 1000);

                        currentResponses = data.responses;

                        pagination.set(data.page_info);
                        renderResponses(data.responses, nodes.responses.wrap);
                        renderMetrics(data.metrics, data.benchmarks);

                        nodes.resultWrap.classList.remove("loading");
                        nodes.resultWrap.classList.remove("hide");

                        queryParams.numPages = data.page_info.num_pages;
                        startedGetContacts = false;

                        loaderElement.classList.add("disabled");
                        initialLoader.loadFinish();

                        dataTimeManager.abort({success: true});
                        contactsProgress.loadFinish();
                        contactsProgress.wrap.classList.add("disabled");
                        filtersProgress.loadFinish();
                        filtersProgress.node.classList.add("disabled");
                        nodes.pagination.wrap.style.display = "flex";
                        nodes.waitMessage.classList.add("disabled");

                        if(callback) {
                            callback(data); 
                        }
                    }
                });
            };

            xhr.send();

        };
        
        dataTimeManager.interval(dataRequest);

    };

    function renderMetrics(metrics, benchmarks) {
        if(browser_storage.getItem("responses-metrics-collapse-v2") === "true") {
            nodes.miniMetrics.score.classList.add("toggling");
            nodes.miniMetrics.responses.classList.add("toggling");
            nodes.miniMetrics.responseRate.classList.add("toggling");
        } else {
            nodes.metrics.result.classList.add("toggling");
            nodes.metrics.status.classList.add("toggling");
            nodes.metrics.rate.classList.add("toggling");
        }

        // large metrics
        nodes.metrics.detractors.innerText = metrics.nps.detractors;
        nodes.metrics.passives.innerText = metrics.nps.passives;
        nodes.metrics.promoters.innerText = metrics.nps.promoters;
        nodes.metrics.result.innerText = metrics.nps.result;
        nodes.metrics.responded.innerText = metrics.response_stats.responded;
        nodes.metrics.status.innerText = metrics.response_stats.responded;
        nodes.metrics.sent.innerText = metrics.response_stats.sent;

        // mini metrics
        nodes.miniMetrics.detractors.innerText = metrics.nps.detractors;
        nodes.miniMetrics.passives.innerText = metrics.nps.passives;
        nodes.miniMetrics.promoters.innerText = metrics.nps.promoters;
        nodes.miniMetrics.score.innerText = metrics.nps.result;
        nodes.miniMetrics.responses.innerText = metrics.response_stats.responded;

        if(!metrics.response_stats.rate || metrics.response_stats.rate == '0.0') {
            nodes.metrics.rate.innerText = 'N/A';
            nodes.miniMetrics.responseRate.innerText = 'N/A';
        } else {
            nodes.metrics.rate.innerHTML = `${metrics.response_stats.rate}<div class="symbol">%</div>`;
            nodes.miniMetrics.responseRate.innerHTML = metrics.response_stats.rate;
        }

        setTimeout(() => {
            if(browser_storage.getItem("responses-metrics-collapse-v2") === "true") {
                nodes.miniMetrics.score.classList.remove("toggling");
                nodes.miniMetrics.responses.classList.remove("toggling");
                nodes.miniMetrics.responseRate.classList.remove("toggling");
            } else {
                nodes.metrics.result.classList.remove("toggling");
                nodes.metrics.status.classList.remove("toggling");
                nodes.metrics.rate.classList.remove("toggling");
            }
        }, 100)
        
        if (metrics.response_stats.sent) {
            nodes.metrics.wrap.classList.remove("show-tooltip");
        } else {
            nodes.metrics.wrap.classList.add("show-tooltip");
        }

        // benchmarks 
        let scoreBenchmarks = document.querySelector(".card.main-score .benchmarking");
        let responseRateBenchmarks = document.querySelector(".card.response-rate .benchmarking");

        let applyBenchmarks = (benchmarkWrapper, type) => {
            let mainScoreBenchmark = benchmarks[`${type}_median`];
            let topTenBenchmark = benchmarks[`top_${type}_median`];

            // benchmark elements
            let allCompaniesElement = benchmarkWrapper.querySelector(".bm-score.all");
            let topTenElement = benchmarkWrapper.querySelector(".bm-score.top10");
            let mainDeltaElement = benchmarkWrapper.querySelector(".diff.all");
            let topDeltaElement = benchmarkWrapper.querySelector(".diff.top10");

            mainDeltaElement.classList.remove("negative", "positive");
            topDeltaElement.classList.remove("negative", "positive");
            allCompaniesElement.innerHTML = "N/A";
            topTenElement.innerHTML = "-";
            mainDeltaElement.innerHTML = "N/A";
            topDeltaElement.innerHTML = "N/A";

            if(mainScoreBenchmark) {
                let percentSign = type === "response_rate" ? "%" : "";
                allCompaniesElement.innerText = mainScoreBenchmark.toFixed(1) + percentSign;
                
                if(topTenBenchmark) {
                    topTenElement.innerText = topTenBenchmark.toFixed(1) + percentSign;
                }

                // deltas
                let customerScore = type === "score" ? metrics.nps.result : metrics.response_stats.rate; 
                
                let renderDeltas = (element, benchmarkScore) => {
                    let delta = customerScore - benchmarkScore;

                    let symbol = "";

                    if(Math.floor(delta) === 0) {
                        delta = 0;
                    }

                    if(Math.floor(delta) < 0) {
                        element.classList.add("negative");
                        symbol = "-";
                    }

                    if (Math.floor(delta) > 0) {
                        element.classList.add("positive");
                        symbol = "+";
                    }

                    element.innerHTML = `<div class="symbol">${symbol}</div>${Math.abs(delta).toFixed(1)}`;
                }

                // apply delta values for All Companies
                renderDeltas(mainDeltaElement, mainScoreBenchmark);
                
                if(topTenBenchmark) {
                    // apply delta values for Top 10%
                    renderDeltas(topDeltaElement, topTenBenchmark);
                }
            }

            
        }

        // apply benchmarks to CSAT Main Score
        applyBenchmarks(scoreBenchmarks, "score");
        // apply benchmarks to CSAT Response Rate
        applyBenchmarks(responseRateBenchmarks, "response_rate");

        metricsComponent.adjustMetricsHeight();
        
    }

    let marketingPermissionsValid = document.querySelector(".result").getAttribute("data-has-marketing-permissions") === "False" ? false : true;

    let unpublishResponse = (id) => fetch(urls['nps:un-publish'](id));

    let ajaxPublishResponse = (event) => {

        let score = parseInt(event.target.getAttribute("data-score"), 10);
        if (score < 9) {
            event.target.checked = false;
            return;
        }

        let xhr = new XMLHttpRequest();

        let id = event.target.getAttribute("data-response-id");
        let company = event.target.getAttribute("data-company");
        let contact = event.target.getAttribute("data-contact");
        
        if (event.target.checked) { // publish
            params = {
                "resp_id" : id,
                "company" : company,
                "contact" : contact
            }
            xhr.open('GET', `${urls['nps:publish']()}?data=${encodeURIComponent(JSON.stringify(params))}`, true);
        } else { // unpublish
            xhr.open('GET', urls['nps:un-publish'](id), true);
        }

        xhr.send();
    }

    let deleteResponse = (id) => {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', urls['nps:delete-response'](id), true);

        xhr.onreadystatechange = () => {

            if (xhr.readyState !== 4) {
                return;
            }
            
            let data;

            try {
                data = JSON.parse(xhr.responseText);
            } catch (e) {
                data = {success: false};
            }

            if(!data.success) {
                let deleteErrorModal = document.querySelector(".modal-template-delete-error_js");
                createdModal.open({
                    class: "error-modal",
                    content: deleteErrorModal.innerHTML,
                    title: ""
                }, function (el) {
                    el.querySelector(".button-primary").addEventListener("click", createdModal.close);
                });

                return;
            }
            
            let row = document.querySelector(`tr[data-response-id="${id}"`);
            row.classList.add("deleted");

            setTimeout(() => {
                row.remove();
                getData();
            }, 400)
        }

        xhr.send();
    }

    let showHideTableScroll = () => {
        let table = nodes.resultWrap.querySelector("table");
        
        if(table.offsetWidth > nodes.resultWrap.offsetWidth) {
            nodes.scrollButtons.wrapper.classList.remove("hide");
        } else {
            nodes.scrollButtons.wrapper.classList.add("hide");
        }
    }

    let makeTableScrollNow = () => {
        let tableWrap = nodes.resultWrap.querySelector(".result");
        let scrollLeft = 0;

        nodes.scrollButtons.left.addEventListener("click", () => {
            scrollLeft -= tableWrap.offsetWidth - 180;
            tableWrap.scroll({
                left: scrollLeft,
                behavior: "smooth",
            });
        });

        nodes.scrollButtons.right.addEventListener("click", () => {
            scrollLeft += tableWrap.offsetWidth - 180;
            tableWrap.scroll({
                left: scrollLeft,
                behavior: "smooth",
            });
        });

        tableWrap.addEventListener("scroll", () => {
            let scrollLeft = tableWrap.scrollLeft;
            let maxScrollLeft = tableWrap.scrollWidth - tableWrap.offsetWidth;

            if(scrollLeft === 0) {
                nodes.scrollButtons.left.classList.add("disabled");
            } else {
                nodes.scrollButtons.left.classList.remove("disabled");
            }

            if(maxScrollLeft === scrollLeft) {
                nodes.scrollButtons.right.classList.add("disabled");
            } else {
                nodes.scrollButtons.right.classList.remove("disabled");
            }
        });
    }

    let renderResponses = (responses, responsesNode) => {
        let tbody = document.querySelector(".contacts-table tbody");
        tbody.innerHTML = "";

        if (responses.length === 0) {
            document.querySelector(".table-pagination__page span").innerText = "0";
            nodes.noResultsTable.classList.remove("hide");
            nodes.tableScrollWrap.classList.add("hide");
        }

        iterate(responses, function (item, i) {
            let oddEven = i % 2 === 0 ? 'even' : 'odd';
            let className;
            switch (item.reaction_type) {
                case 0:
                    className = "warning";
                    break;
                case 1:
                    className = "primary";
                    break;
                case -1:
                    className = "danger";
                    break;
            }
            let more = "";
            let comment = item.comment || "";
            let checkmark = item.score > 8 ? '<span class="checkmark-svg"></span>' : '<span class="no-permissions">&times;</span>'
            let marketingPermissionsMessage = comment === "" ? '–<div class="tooltip"><br>No comment provided<br><br></div>' : '-';

            let publishedToggle = (state, id, company, fullName, score) => {
                let publishDisabledByScore = score < 9;
                return `<div class="mini-toggle ${publishDisabledByScore ? 'disabled' : ''}">
                    <input id="publishReview_${id}" class="publish-toggle" type="checkbox" data-company="${company}" data-contact="${fullName}" data-response-id="${id}" data-score="${score}" ${publishDisabledByScore ? 'disabled' : ''} ${!publishDisabledByScore && state ? 'checked' : ''}>
                    <label for="publishReview_${id}"></label>
                </div>`;
            }

            let publishTooltip = item.comment ? '<div class="sb-tooltip">Marketing permission not provided' : '<div class="sb-tooltip no-comment">Comment not provided</div>';

            let publishColumn = '';
            let deleteColumn = '';

            let configuredColumns = '';
            let configuredColumnsCount = 0;

            // iterate through filterNameMapping to maintain consistent order of columns / filters / etc
            iterate(constants.filterNameMapping, (value, key) => {
                if(tableColumns.includes(key)) {
                    let data = item[constants.filterNameMapping[key].table_key];

                    if((key === "is_primary" || key === "is_billing") && data === true) data = "Yes";

                    if(Array.isArray(data)) {
                        data = data.map(item => utilities.sanitizeData(item)).join(", ");
                    }

                    configuredColumns += `<td class="${key}-td">${data || '<div class="no-data">–</div>'}</td>`;
                    configuredColumnsCount++;
                }
            });

            if(isAdmin) {
                let publishDisabledByScore = item.score < 9;
                let scoreTooltip = publishDisabledByScore ? '<div class="sb-tooltip">Only response of 9 or 10 with marketing permission can be published to the widget</div>' : '';

                publishColumn = `
                    <td class="publish-td publish-review tooltip-wrap ${marketingPermissionsValid ? '' : 'invalid'}">
                        ${item.has_marketing_permission ? `${publishedToggle(item.is_published, item.resp_id, item.company, item.full_name, item.score)}${scoreTooltip}` : `–${publishTooltip}`}
                    </td>
                `;

                deleteColumn = `
                    <td class="remove-response-td">
                        <div class="flex-wrapper">
                            <div
                                data-id="${item.resp_id}"
                                data-score="${item.score}"
                                data-contact="${utilities.sanitizeData(item.full_name)}"
                                role="button"
                                class="btn btn-primary edit-nps-response icon glyphicons glyphicons-pencil">
                            </div>
                            <div
                                data-id="${item.resp_id}"
                                data-contact="${utilities.sanitizeData(item.full_name)}"
                                role="button"
                                class="btn btn-danger remove-response icon glyphicons glyphicons-remove">
                            </div>
                        </div>
                    </td>
                `;
            }

            let sentiment = utilities.generateSentiment('nps', item.score);

            let html = `
                    <td class="score-td sticky-col"><div class="score ${sentiment}">${item.score}</div></td>
                    <td class="full-name-td">${utilities.sanitizeData(item.full_name)}</td>
                    <td class="date">${moment(item.last_modified).format('DD MMM YYYY')}</td>
                    ${configuredColumns}
                    ${publishColumn}
                    ${deleteColumn}
            `;

            let tr = document.createElement("tr");
            tr.setAttribute("data-response-id", item.resp_id);
            tr.classList.add(oddEven);
            tr.innerHTML = html;

            let removeButton = tr.querySelector(".remove-response");

            if(removeButton) {
                removeButton.addEventListener("click", () => {
                    const id = removeButton.dataset.id;
                    const contactName = removeButton.dataset.contact;
                    const deleteTemplate = document.querySelector(".modal-template-delete-response_js");

                    const createdDeleteModal = createdModal.open({
                        class: deleteTemplate.dataset.class,
                        content: `
                            <p class="alert alert-info">Removing this response will alter your NPS Score and Response Rate.</p>
                            <div class="delete-response-actions">
                                <button class="button-primary confirm-delete-nps-response">Confirm Delete</button>
                                <button class="button-secondary close-sb-modal_js">Cancel</button>
                            </div>
                        `,
                        title: deleteTemplate.dataset.title,
                    }, (el, modal) => {
                        const titleEl = document.querySelector(".modal-title_js");
                        const nameSpan = document.createElement("span");
                        nameSpan.textContent = contactName;
                        nameSpan.classList.add("modal-contact-name");
                        titleEl.appendChild(nameSpan);

                        el.querySelector(".confirm-delete-nps-response").addEventListener("click", () => {
                            createdModal.close();
                            deleteResponse(id);
                        });
                        el.querySelector(".close-sb-modal_js").addEventListener("click", createdModal.close);
                    });
                });
            }

            let editButton = tr.querySelector(".edit-nps-response");

            if(editButton) {
                editButton.addEventListener("click", () => {
                    const id = editButton.dataset.id;
                    const currentScore = editButton.dataset.score;
                    const contactName = editButton.dataset.contact;
                    const editTemplate = document.querySelector(".modal-template-edit-response_js");

                    const scoreOptions = [0,1,2,3,4,5,6,7,8,9,10].map(n =>
                        `<option value="${n}" ${String(n) === String(currentScore) ? 'selected' : ''}>${n}</option>`
                    ).join('');

                    const formContent = `
                        <form class="edit-nps-response-form">
                            <div class="edit-response-row">
                                <label class="edit-response-label">Score</label>
                                <div class="custom-select edit-nps-score-select no-search" style="z-index: 15">
                                    <select class="nps-score-select">
                                        ${scoreOptions}
                                    </select>
                                    <img src="/static/icons/select-arrow.svg" alt="">
                                </div>
                            </div>
                            <button type="button" class="button-primary save-edit-nps-response">Save</button>
                        </form>
                    `;

                    createdModal.open({
                        class: editTemplate.dataset.class,
                        content: formContent,
                        title: editTemplate.dataset.title,
                    }, (el) => {
                        const titleEl = document.querySelector(".modal-title_js");
                        const nameSpan = document.createElement("span");
                        nameSpan.textContent = contactName;
                        nameSpan.classList.add("modal-contact-name");
                        titleEl.appendChild(nameSpan);

                        const scoreSelectWrap = el.querySelector(".edit-nps-score-select");

                        DD(scoreSelectWrap);

                        el.querySelector(".save-edit-nps-response").addEventListener("click", () => {
                            const updatedScore = scoreSelectWrap.querySelector("select").value;
                            const updatedScoreNum = parseInt(updatedScore, 10);
                            const row = document.querySelector(`tr[data-response-id="${id}"]`);
                            const publishToggle = row && row.querySelector('.publish-toggle');
                            const wasPublished = publishToggle && publishToggle.checked;

                            createdModal.close();

                            const saveScoreEdit = () => fetch(`/nps/response/edit/${id}/`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ score: updatedScore }),
                            }).then(() => getData());

                            if (updatedScoreNum < 9 && wasPublished) {
                                unpublishResponse(id).finally(saveScoreEdit);
                            } else {
                                saveScoreEdit();
                            }
                        });
                    });
                });
            }

            tbody.appendChild(tr);

            let commentRow = '';
            let baseColumnCount = 4; // score, date, name, company
            let adminColumns = 2; // publish toggle and delete button

            let columnCount = baseColumnCount + configuredColumnsCount + (isAdmin ? adminColumns : 0);

            if(comment) {
                commentRow = document.createElement("tr");
                commentRow.classList.add("comment-row");
                commentRow.innerHTML = `
                    <td class="sticky-col" colspan="1"></td>
                    <td class="comment-td" colspan=${columnCount}>
                        <div class="comment-wrapper">
                            <div class="comment-block">${comment}</div>
                            <a class="more button-tertiary">More</a>
                        </div>
                    </td>`;

                tbody.appendChild(commentRow);

                let flag = false;

                commentRow.querySelector(".more").addEventListener("click", function () {
                    let wrap = commentRow.querySelector(".comment-block");
                    if (!flag) {
                        flag = true;
                        wrap.classList.add("open")
                        this.innerText = "less";
                    } else {
                        wrap.classList.remove("open")
                        flag = false;
                        this.innerText = "more";
                    }
                });
            }
        });

        iterate(tbody.querySelectorAll(".publish-toggle"), (toggle) => {
            toggle.addEventListener("change", ajaxPublishResponse);
        });

        iterate(tbody.querySelectorAll(".comment-td") || [], (wrap) => {
            let node = wrap.querySelector(".comment-block");
            if (node.offsetWidth < 800) {
                wrap.parentElement.querySelector(".more").style.display = "none";
            }
        });

        showHideTableScroll();
        makeTableScrollNow();
    }

    let error_modal = document.querySelector(".modal-template-error_js");   

    let renderPageSettings = () => {
        let output = '';
        let mandatoryTableColumns = ["sentiment", "full_name", "date", "comment"];

        // generate table column toggles based on tableColumns config
        iterate(constants.filterNameMapping, (value, key) => {
            if(availableColumns.includes(key) && !mandatoryTableColumns.includes(key)) { //mandatory columns are hard coded in template
                output += `
                    <div class="mini-toggle field">
                        <input type="checkbox" class="column-toggle" id="${key}Toggle" data-property="${key}" ${tableColumns.includes(key) ? 'checked' : ''}>
                        <label for="${key}Toggle">
                            <div class="status">${constants.filterNameMapping[key].singular}</div>
                        </label>
                        <div class="description"><font dir="auto" style="vertical-align: inherit;"><font dir="auto" style="vertical-align: inherit;">${constants.filterNameMapping[key].singular}</font></font></div>
                    </div>
                `;
            }
        });

        nodes.pageSettingsContent.querySelector('.column-toggle-wrap').innerHTML = output;

        // add event listeners for column toggles
        let columnToggles = nodes.pageSettingsContent.querySelectorAll(".column-toggle");

        columnToggles.forEach(toggle => {
            toggle.addEventListener("change", (event) => {
                let property = event.target.getAttribute("data-property");

                if(event.target.checked) {
                    if(!tableColumns.includes(property)) {
                        tableColumns.push(property);
                    }
                } else {
                    if(tableColumns.includes(property)) {
                        tableColumns = tableColumns.filter(column => column !== property);
                    }
                }

                browser_storage.setItem("nps-responses-table-columns", JSON.stringify(tableColumns));
                
                loaderElement.classList.remove("disabled");
                nodes.resultWrap.querySelector("table").remove();
                createResponsesTable(true);
            });
        });
    }

    let initTableFunctionality = () => {
        pagination = initPagination(nodes.pagination, function (value) {
            queryParams.page = value;
            getData();
        }, queryParams);

        var releaseSearch = () => {
            nodes.searchField.searchField.disabled = false;
            nodes.searchField.searchField.focus();
        }

        var searchField = initSearchField(nodes.searchField, function (value) {
            nodes.searchField.searchField.disabled = true;
            queryParams["q"] = customEncodeUri(value);
            
            queryParams.page = 1;
            getData(() => {
                releaseSearch();
            });

        }, {next: queryParams.q});
    };

    let createResponsesTable = (reRenderResponses) => {

        let resultsTable = document.querySelector(".result");

        let table = document.createElement('table');
        table.classList.add("contacts-table");

        let arrowHtml = '<img class="select-arrow-icon" src="/static/icons/down.svg" alt="">';

        let permissionsTooltip = marketingPermissionsValid ? '' : (
            '<div class="tooltip">You can enable marketing permissions for your reviews when you create or manage NPS campaigns</div>');


        let publishHeader = '';
        let deleteHeader = '';

        let configuredHeaderColumns = '';

        // iterate through filterNameMapping to dictate correct order of columns in table header based on tableColumns config
        iterate(constants.filterNameMapping, (value, key) => {
            if(tableColumns.includes(key)) {
                configuredHeaderColumns += `<td class="sortable asc ${key}-td" data-id="${constants.filterNameMapping[key].table_key}">${constants.filterNameMapping[key].singular} ${arrowHtml}</td>`;
            }
        });

        if(isAdmin) {
            publishHeader = `
                <td class="publish-td ${marketingPermissionsValid ? 'sortable' : 'invalid'}"
                    data-id="is_published">
                        Publish Comment&nbsp;${marketingPermissionsValid ? arrowHtml : ''}
                        ${permissionsTooltip}
                </td>
            `;

            deleteHeader = `
                <td class="remove-response-td center">Controls</td>
            `
        }

        const tableHtml = `
            <thead>
                <tr>
                    <td class="sortable asc score-td sticky-col" data-id="score">Score ${arrowHtml}</td>
                    <td class="sortable asc full-name-td " data-id="full_name">Contact name ${arrowHtml}</td>
                    <td class="sortable desc date-td active" data-id="date">Date ${arrowHtml}</td>
                    ${configuredHeaderColumns}
                    ${publishHeader}
                    ${deleteHeader}
                </tr>
            </thead>
            <tbody></tbody>`;

        table.innerHTML = tableHtml;

        resultsTable.appendChild(table);

        table.querySelector("thead tr").addEventListener("click", (e) => {

            let el = e.target;
            let key = el.getAttribute("data-id");

            if (key && el.classList.contains("sortable")) {
                let isDesc = el.classList.contains("desc");
                let isAsc = el.classList.contains("asc");

                if (isDesc || isAsc) {
                    queryParams.sort = isAsc ? {[key]: 'desc'} : {[key]: 'asc'};
                } else {
                    queryParams.sort = {[key]: 'desc'};
                }

                getData(() => {
                    iterate(document.querySelectorAll(".sortable"), (node) => {
                        node.classList.remove("asc");
                        node.classList.remove("desc");
                        node.classList.remove("active");
                    });

                    el.classList.add("active");

                    if (queryParams.sort[key] === "asc") {
                        el.classList.add("asc");
                    } else {
                        el.classList.add("desc");
                    }
                });
            }
        });

        if (reRenderResponses) {
            renderResponses(currentResponses, nodes.responses.wrap);
            setTimeout(() => {
                // using set timeout to make loading screen more evident to users, as re-rendering table is very fast
                loaderElement.classList.add("disabled");
                showHideTableScroll();
            }, 100);
        }

        initTableFunctionality();
    }

    return {

        init: function () {

            automationBanner();

            // reset preserved params if user has logged into a different platform account
            let lastPlatform = browser_storage.getItem("platform");

            if(lastPlatform !== platform) {
                browser_storage.removeItem("nps-responses-filter-params");
                browser_storage.removeItem("nps-responses-date-params");
                browser_storage.removeItem("nps-responses-preserve-filters");
                browser_storage.removeItem("nps-responses-table-columns"); 
                preserveFilters = false;
            }

            browser_storage.setItem("platform", platform);

            optimizedResize.add(() => {

                iterate(document.querySelectorAll(".comment-td") || [], (wrap) => {
                    
                    let node = wrap.querySelector(".contacts-table__comment-block");

                    if (!node) return;

                    requestAnimationFrame(() => {
                        node.style.height = "100%";
                    });

                    requestAnimationFrame(() => {
                        if (node.offsetHeight > 40) {
                            node.style.height = "38px";
                            node.parentNode.querySelector(".nps-link").innerText = "more";
                            wrap.querySelector(".more").style.display = "block";
                        } else {
                            wrap.style.height = "auto";
                            wrap.querySelector(".more").style.display = "none";
                        }
                    });
                });

            });


            let limitNode = document.querySelector(".nps-responses-custom-limit_js");
            limitNode.querySelector("select").value = queryParams.limit + "";

            let DDReset = DD(limitNode, (value) => {
                queryParams["limit"] = value;
                queryParams.page = 1;
                getData();
            });

            var classes = {
                CSV: {
                    btn: ".nps-csv-download_js",
                    filter: ".nps-csv-download-filters_js",
                    noFilter: ".nps-csv-download-no-filters_js",
                    modalContent: ".modal-template-csv_js"
                },
            };

            filterBox.create(
                'nps-responses', // page prefix
                urls['nps:response-tss-filters'](), // filter data endpoint
                (qp, dp) => { // on change
                    filterParams = qp;
                    dateParams = dp;
                    getData();
                },
                (data, availableColumnList, preservedFilters) => {
                    availableColumns = availableColumnList;

                    if(preservedFilters) filterParams = preservedFilters;

                    if (platform === "cw") {
                        data.filters.company_statuses = data.filters.company_statuses || ["active","unactive"];
                    }

                    if (!browser_storage.getItem("nps-responses-table-columns")) {
                        tableColumns = availableColumns;
                    }

                    if(preserveFilters === "true" || preserveFilters === true) {
                        filterParams = JSON.parse(browser_storage.getItem("nps-responses-filter-params"));
                        dateParams = JSON.parse(browser_storage.getItem("nps-responses-date-params"));
                    }

                    renderPageSettings(data);
                    getData();
                    createResponsesTable();
                }
            );

            queryParams.page = '1';
            utilities.updateDateStatus(dateParams, nodes.dateStatus, true);

            //init some variables for modal nodes
            var downloadFilter = null;
            var downloadNoFilter = null;

            //button for download csv modal
            var downloadCSVBtn = document.querySelector(classes.CSV.btn);

            downloadCSVBtn.addEventListener("click", function () {
                var content = document.querySelector(classes.CSV.modalContent);
                var title = content.getAttribute("data-title");
                var className = content.getAttribute("data-class");

                let openModal = () => {
                    //Open modal
                    createdModal.open({
                        //set a wrap class for a modal
                        class: className,
                        //set content for a modal
                        content: content.innerHTML,
                        //set title for a modal
                        title: title
                    }, function () {
                        //Bind events when DOM loaded at the modal screen;
                        downloadFilter = document.querySelector(classes.CSV.filter);
                        downloadNoFilter = document.querySelector(classes.CSV.noFilter);
                        downloadFilter.addEventListener("click", downloadCSV);
                        downloadNoFilter.addEventListener("click", downloadCSV);
                    });
                }

                if(dataCacheTimeRemaining > (globals.settings.NPS_CACHE_TTL * 0.1)) {
                    openModal();
                } else {
                    let loaderElement = document.querySelector(".marketing-loader");
                    let hint = loaderElement.querySelector(".loader-bar-wrap_hint");
                    hint.innerText = "Generating CSV for download. Please wait.";
                    loaderElement.classList.remove("disabled");

                    getData(() => {
                        loaderElement.classList.add("disabled");
                        openModal();
                    });
                }
            });

            //function that called when you click how you want to download CSV
            function downloadCSV(event) {
                var url = "";
                if (event.target.getAttribute("data-all")) {
                    url = urls['nps:generate-csv-all']();
                } else {
                    url = urls['nps:generate-csv'](dateParams.date[0], dateParams.date[1]) + "?data=" + encodeURIComponent(JSON.stringify({...filterParams, ...queryParams}));
                }
                window.location.href = url;
                createdModal.close();
            }

            nodes.settingsToggles.forEach(toggle => {
                toggle.addEventListener("click", () => {
                    let selectedSource = toggle.getAttribute("data-source");
                    let requestedContent = document.querySelector(`.settings-content[data-content="${selectedSource}"]`);
                    let currentContentSource = nodes.settingsContent.getAttribute("data-content");
                           
                    if(currentContentSource !== selectedSource) { // update content if different source
                        // update settings source attribute and content
                        nodes.settingsContent.classList.add("transition");
                        
                        if(currentContentSource) {
                            // put current content back to its source container
                            let contentContainer = document.querySelector(`.settings-content[data-content="${currentContentSource}"]`);
                            contentContainer.replaceChildren(...nodes.settingsContent.childNodes);
                        }
                        nodes.settingsContent.setAttribute("data-content", selectedSource);
                        nodes.settingsContent.replaceChildren(...requestedContent.childNodes);
                        utilities.setSettingsHeight(nodes); 
                        nodes.settingsContent.classList.remove("transition");
                    } 

                    if(nodes.settingsPanel.classList.contains("hide")) { 
                        if(currentContentSource !== selectedSource) {
                            nodes.settingsPanel.classList.remove("hide");
                        }
                    }
                })  
            });
        }
    }
});